import { supabase } from '../api/supabase';

export interface Profile {
  id: string;
  role: 'CUSTOMER' | 'HOMEE' | 'BUSINESS';
  full_name: string | null;
  is_verified: boolean;
  is_active: boolean;
  rating: number;
}

export const ProfileRepository = {
  async getOwnProfile(userId: string): Promise<Profile | null> {
    const { data, error } = await supabase.from('profiles').select('*').eq('id', userId).single();
    if (error) return null;
    return data as Profile;
  },

  async setActive(userId: string, isActive: boolean): Promise<void> {
    await supabase.from('profiles').update({ is_active: isActive }).eq('id', userId);
  },

  async updateLocation(userId: string, latitude: number, longitude: number): Promise<void> {
    await supabase
      .from('profiles')
      .update({ last_known_location: `POINT(${longitude} ${latitude})` })
      .eq('id', userId);
  },

  async markIdentityVerified(userId: string): Promise<void> {
    await supabase
      .from('profiles')
      .update({ is_verified: true, identity_verified_at: new Date().toISOString() })
      .eq('id', userId);
  },
};
